import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import PackegeList from '../../components/admincomponents/PackegeList';

function AdminPackage({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <PackegeList  />            
    </>
  );
}

export default AdminPackage;
